import { createContext } from 'react'
import { WorkcellStatus } from '~/api/desktop/workcell.interface'

const WorkcellStatusContext = createContext<WorkcellStatus | undefined>(undefined)

export default WorkcellStatusContext
